/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var Tracking = (function () {
            function Tracking($, headerAnalytics, getInstanceFunction) {
                this.$ = $;
                this.headerAnalytics = headerAnalytics;
                this.getInstanceFunction = getInstanceFunction;
                if (this.$.isNullOrUndefined($)) {
                    throw new Error("'$' was not specified.");
                }
                if (this.$.isNullOrUndefined(headerAnalytics)) {
                    throw new Error("'headerAnalytics' was not specified.");
                }
                if (this.$.isNullOrUndefined(getInstanceFunction)) {
                    throw new Error("'getInstanceFunction' was not specified.");
                }
            }
            Tracking.prototype.replaceVariables = function (value) {
                var $ = this.$;
                if (!$.isString(value)) {
                    return value;
                }
                return value.replace(/\$current_page/g, this.headerAnalytics.getCurrentPageName());
            };
            Tracking.prototype.sendTrackingInfo = function ($source) {
                var $ = this.$;
                var s = this.getInstanceFunction(this.headerAnalytics.getSiteId());
                if ($.isNullOrUndefined(s)) {
                    return;
                }
                var properties = $source.data("tracking-properties");
                var trackEvents = [];
                for (var p in properties) {
                    if (properties.hasOwnProperty(p)) {
                        s[p] = this.replaceVariables(properties[p]);
                        trackEvents.push(p);
                    }
                }
                var events = $source.data("tracking-event-variables");
                for (var e in events) {
                    if (events.hasOwnProperty(e)) {
                        s[e] = this.replaceVariables(events[e]);
                        trackEvents.push(e);
                    }
                }
                s.linkTrackVars = trackEvents.join(",");
                s.linkTrackEvents = $source.data("tracking-link-track-events");
                s.events = $source.data("tracking-event-names");
                // The first parameter should be a reference to the hyperlink if it was a hyperlink, or true otherwise.
                // See http://microsite.omniture.com/t2/help/en_US/sc/implement/oms_sc_implement.pdf
                var item = true;
                if ($source.is("a")) {
                    item = $source.get(0);
                }
                s.tl(item, "o", $source.data("tracking-event-description"));
            };
            Tracking.prototype.initialize = function ($context) {
                var $ = this.$;
                var self = this;
                var initTracking = function (index, element) {
                    $(element).on("click", function () {
                        self.sendTrackingInfo($(this));
                    });
                };
                $(".tracking", $context).each(initTracking);
            };
            return Tracking;
        }());
        Header.Tracking = Tracking;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=header-tracking.js.map
